// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.layout-section {
  padding: 1rem;
}

.dropzone {
  position: relative;
  height: 200px;
  width: 100%;
  border: 2px dashed #D1D5DB;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dropzone input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.dropzone .textLink {
  color: #1F2937 !important;
}
.dropzone .textLink u {
  text-decoration: underline;
  margin-left: 4px;
}

.fileupload-info {
  background: #f6f8ff;
  padding: 15px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.fileupload-text {
  display: block;
  width: 85%;
  word-wrap: break-word;
}

.table-wrapper {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.table-header .user-label img {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.table-header .user-label .layout-header-icon {
  filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(212deg) brightness(97%) contrast(92%) !important;
  width: 24px;
  height: 24px;
}

:host ::ng-deep p-button.sub-layout-add-button {
  opacity: 1 !important;
}
:host ::ng-deep p-button.sub-layout-add-button,
:host ::ng-deep p-button.sub-layout-add-button * {
  opacity: 1 !important;
}
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(:disabled):not([disabled]),
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(:disabled):not([disabled]),
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(.p-disabled),
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(.p-disabled) {
  opacity: 1 !important;
  cursor: pointer !important;
  background-color: #fff !important;
  color: #1E38A9 !important;
  border: 1px solid #1E38A9 !important;
}
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(:disabled):not([disabled]):hover,
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(:disabled):not([disabled]):hover,
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(.p-disabled):hover,
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(.p-disabled):hover {
  opacity: 1 !important;
  background: #f3f4f6 !important;
  color: #1E38A9 !important;
  border-color: #1E38A9 !important;
}
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(:disabled):not([disabled]):active, :host ::ng-deep p-button.sub-layout-add-button button.p-button:not(:disabled):not([disabled]):focus,
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(:disabled):not([disabled]):active,
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(:disabled):not([disabled]):focus,
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(.p-disabled):active,
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(.p-disabled):focus,
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(.p-disabled):active,
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(.p-disabled):focus {
  opacity: 1 !important;
  background-color: #fff !important;
  color: #1E38A9 !important;
  border: 1px solid #1E38A9 !important;
}
:host ::ng-deep p-button.sub-layout-add-button button.p-button:disabled,
:host ::ng-deep p-button.sub-layout-add-button .p-button:disabled,
:host ::ng-deep p-button.sub-layout-add-button button.p-button[disabled],
:host ::ng-deep p-button.sub-layout-add-button .p-button[disabled],
:host ::ng-deep p-button.sub-layout-add-button button.p-button.p-disabled,
:host ::ng-deep p-button.sub-layout-add-button .p-button.p-disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}
:host ::ng-deep .gc-form-section .gc-form-section-heading.collapsed {
  border-bottom: none !important;
}
:host ::ng-deep .gc-form-section .sidebar-form label {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 30px;
  color: #1E38A9;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext {
  height: 54px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
  margin-bottom: 0;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext:enabled:focus {
  box-shadow: none;
  border-color: #D1D5DB;
}
:host ::ng-deep .gc-form-section .sidebar-form .grid.p-fluid .col-12 {
  margin-bottom: 0.5rem;
}
:host ::ng-deep .gc-form-section .sidebar-form .grid.p-fluid .col-12:last-child {
  margin-bottom: 0;
}
:host ::ng-deep .gc-form-section .sidebar-form .nested-form-group {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border: 1px solid #dee2e6;
}
:host ::ng-deep .gc-form-section .sidebar-form .nested-form-group h4, :host ::ng-deep .gc-form-section .sidebar-form .nested-form-group h5 {
  margin: 0;
  color: #1E38A9;
  font-weight: 600;
  font-size: 18px;
}
:host ::ng-deep .gc-form-section .sidebar-form .nested-form-group .grid.p-fluid {
  margin-bottom: 0;
}
:host ::ng-deep .gc-form-section .sidebar-form .gc-form-section .gc-form-section {
  margin-bottom: 1rem;
  border: 1px solid #e5e7eb;
}
:host ::ng-deep .gc-form-section .sidebar-form .gc-form-section .gc-form-section .gc-form-section-heading {
  padding: 12px 16px;
}
:host ::ng-deep .gc-form-section .sidebar-form .gc-form-section .gc-form-section .gc-form-section-heading h4 {
  font-size: 16px;
}
:host ::ng-deep .gc-form-section .sidebar-form .gc-form-section .gc-form-section .sidebar-form {
  padding: 16px;
}
:host ::ng-deep .p-sidebar-right {
  width: 704px !important;
}
:host ::ng-deep .p-sidebar button.p-button-danger,
:host ::ng-deep .p-sidebar .p-button-danger,
:host ::ng-deep .p-sidebar button.p-button.p-button-danger,
:host ::ng-deep .p-sidebar .p-button.p-button-danger,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger.p-button-sm,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger.p-button-sm,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger.p-button-sm,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger.p-button-sm {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  color: #dc3545 !important;
  box-shadow: none !important;
}
:host ::ng-deep .p-sidebar button.p-button-danger:hover,
:host ::ng-deep .p-sidebar .p-button-danger:hover,
:host ::ng-deep .p-sidebar button.p-button.p-button-danger:hover,
:host ::ng-deep .p-sidebar .p-button.p-button-danger:hover,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger.p-button-sm:hover,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger.p-button-sm:hover,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger.p-button-sm:hover,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger.p-button-sm:hover {
  background: rgba(220, 53, 69, 0.1) !important;
  background-color: rgba(220, 53, 69, 0.1) !important;
  color: #c82333 !important;
}
:host ::ng-deep .p-sidebar button.p-button-danger:focus, :host ::ng-deep .p-sidebar button.p-button-danger:active,
:host ::ng-deep .p-sidebar .p-button-danger:focus,
:host ::ng-deep .p-sidebar .p-button-danger:active,
:host ::ng-deep .p-sidebar button.p-button.p-button-danger:focus,
:host ::ng-deep .p-sidebar button.p-button.p-button-danger:active,
:host ::ng-deep .p-sidebar .p-button.p-button-danger:focus,
:host ::ng-deep .p-sidebar .p-button.p-button-danger:active,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger.p-button-sm:focus,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger.p-button-sm:active,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger.p-button-sm:focus,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger.p-button-sm:active,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger.p-button-sm:focus,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger.p-button-sm:active,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger.p-button-sm:focus,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger.p-button-sm:active {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep .p-sidebar button.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar button.p-button-danger .pi,
:host ::ng-deep .p-sidebar .p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar .p-button-danger .pi,
:host ::ng-deep .p-sidebar button.p-button.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar button.p-button.p-button-danger .pi,
:host ::ng-deep .p-sidebar .p-button.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar .p-button.p-button-danger .pi,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger.p-button-sm .p-button-icon,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger.p-button-sm .pi,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger.p-button-sm .p-button-icon,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger.p-button-sm .pi,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger.p-button-sm .p-button-icon,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger.p-button-sm .pi,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger.p-button-sm .p-button-icon,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger.p-button-sm .pi {
  color: #dc3545 !important;
}
:host ::ng-deep .p-sidebar p-button button.p-button-danger,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-danger,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger.p-button-sm,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger.p-button-sm,
:host ::ng-deep .p-sidebar p-button button.p-button.p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  color: #dc3545 !important;
  box-shadow: none !important;
}
:host ::ng-deep .p-sidebar p-button button.p-button-danger:hover,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-danger:hover,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger.p-button-sm:hover,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger.p-button-sm:hover,
:host ::ng-deep .p-sidebar p-button button.p-button.p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger:hover {
  background: rgba(220, 53, 69, 0.1) !important;
  background-color: rgba(220, 53, 69, 0.1) !important;
  color: #c82333 !important;
}
:host ::ng-deep .p-sidebar p-button button.p-button-danger:focus, :host ::ng-deep .p-sidebar p-button button.p-button-danger:active,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-danger:focus,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-danger:active,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger.p-button-sm:focus,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger.p-button-sm:active,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger.p-button-sm:focus,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger.p-button-sm:active,
:host ::ng-deep .p-sidebar p-button button.p-button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar p-button button.p-button.p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger:active {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep .p-sidebar p-button button.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar p-button button.p-button-danger .pi,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-danger .pi,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger.p-button-sm .p-button-icon,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger.p-button-sm .pi,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger.p-button-sm .p-button-icon,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger.p-button-sm .pi,
:host ::ng-deep .p-sidebar p-button button.p-button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar p-button button.p-button.p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger .pi {
  color: #dc3545 !important;
}
:host ::ng-deep .p-checkbox .p-checkbox-box {
  border-color: #1E38A9;
}
:host ::ng-deep .p-checkbox .p-checkbox-box.p-highlight {
  background-color: #2d388b;
  border-color: #2d388b !important;
}
:host ::ng-deep .p-dropdown {
  height: 54px;
}
:host ::ng-deep .p-dropdown .p-dropdown-label {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 12px 16px;
  line-height: 30px;
}
:host ::ng-deep .p-dropdown .p-dropdown-trigger {
  display: flex;
  align-items: center;
}
:host ::ng-deep .p-dropdown.p-dropdown-empty .p-dropdown-label {
  display: flex;
  align-items: center;
}
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button {
  width: auto !important;
  min-width: 80px;
  display: inline-block;
  opacity: 1 !important;
}
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button {
  width: auto !important;
}
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button:not([disabled]):not(.p-disabled),
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button:not([disabled]):not(.p-disabled),
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button:not([disabled]):not(.p-disabled) {
  opacity: 1 !important;
  cursor: pointer !important;
  background-color: #fff !important;
  color: #1E38A9 !important;
  border: 1px solid #1E38A9 !important;
  transition: all 0.2s ease !important;
}
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button:not([disabled]):not(.p-disabled):hover,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button:not([disabled]):not(.p-disabled):hover,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button:not([disabled]):not(.p-disabled):hover {
  background: #f3f4f6 !important;
  color: #1E38A9 !important;
  border-color: #1E38A9 !important;
  opacity: 1 !important;
}
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button:not([disabled]):not(.p-disabled):active, :host ::ng-deep ::ng-deep p-button.sub-layout-add-button button:not([disabled]):not(.p-disabled):focus,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button:not([disabled]):not(.p-disabled):active,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button:not([disabled]):not(.p-disabled):focus,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button:not([disabled]):not(.p-disabled):active,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button:not([disabled]):not(.p-disabled):focus {
  background-color: #fff !important;
  color: #1E38A9 !important;
  border: 1px solid #1E38A9 !important;
  opacity: 1 !important;
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button[disabled], :host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-disabled, :host ::ng-deep ::ng-deep p-button.sub-layout-add-button button:disabled,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button[disabled],
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button.p-disabled,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button:disabled,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button[disabled],
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button.p-disabled,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}
:host ::ng-deep .p-sidebar *[class*=p-button-danger], :host ::ng-deep .p-sidebar *.p-button-danger {
  background: transparent !important;
  background-color: transparent !important;
}
:host ::ng-deep .p-sidebar p-button *[class*=p-button-danger], :host ::ng-deep .p-sidebar p-button *.p-button-danger {
  background: transparent !important;
  background-color: transparent !important;
}

.gc-form-section {
  margin-bottom: 2rem;
}

.sidebar-form {
  padding: 0.5rem;
}

.red {
  color: #FF3C3C;
  margin-left: 2px;
}

.popup-wrapper {
  position: relative;
}

.sidebar-interaction-blocker {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  z-index: 1000;
  cursor: not-allowed;
}

.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer:hover {
  opacity: 0.8;
}
.cursor-pointer.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.gc-form-heading {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1E38A9;
}

.gc-form-section-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.gc-form-section-heading.cursor-pointer {
  -webkit-user-select: none;
          user-select: none;
}
.gc-form-section-heading.cursor-pointer h3, .gc-form-section-heading.cursor-pointer h4, .gc-form-section-heading.cursor-pointer h5 {
  -webkit-user-select: none;
          user-select: none;
}
.gc-form-section-heading .pi {
  font-size: 0.875rem;
  transition: transform 0.2s;
}
.gc-form-section-heading.collapsed {
  border-bottom: none !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/colors.scss","webpack://./src/app/layout/layout.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACEA;EACE,aAAA;AAEF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;AACJ;AAEE;EACE,yBAAA;AAAJ;AAEI;EACE,0BAAA;EACA,gBAAA;AAAN;;AAKA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAFF;;AAKA;EACE,cAAA;EACA,UAAA;EACA,qBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAFF;AAMI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAJN;AAOI;EACE,uIAAA;EAEA,WAAA;EACA,YAAA;AANN;;AAcE;EACE,qBAAA;AAXJ;AAcI;;EAEE,qBAAA;AAZN;AAeI;;;;EAIE,qBAAA;EACA,0BAAA;EACA,iCAAA;EACA,yBAAA;EACA,oCAAA;AAbN;AAeM;;;;EACE,qBAAA;EACA,8BAAA;EACA,yBAAA;EACA,gCAAA;AAVR;AAaM;;;;;;;EAEE,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,oCAAA;AANR;AAWI;;;;;;EAME,uBAAA;EACA,8BAAA;AATN;AAgBM;EACE,8BAAA;AAdR;AAoBM;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cDzHM;ACuGd;AAsBM;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AApBR;AAqBQ;EACE,gBAAA;EACA,qBAAA;AAnBV;AAyBQ;EACE,qBAAA;AAvBV;AAyBU;EACE,gBAAA;AAvBZ;AA4BM;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AA1BR;AA4BQ;EACE,SAAA;EACA,cDnKI;ECoKJ,gBAAA;EACA,eAAA;AA1BV;AA6BQ;EACE,gBAAA;AA3BV;AAgCQ;EACE,mBAAA;EACA,yBAAA;AA9BV;AAgCU;EACE,kBAAA;AA9BZ;AA+BY;EACE,eAAA;AA7Bd;AAiCU;EACE,aAAA;AA/BZ;AAsCE;EACE,uBAAA;AApCJ;AA4CI;;;;;;;;;;;;EAYE,kCAAA;EACA,wCAAA;EACA,uBAAA;EACA,yBAAA;EACA,2BAAA;AA1CN;AA4CM;;;;;;;;;;;;EACE,6CAAA;EACA,mDAAA;EACA,yBAAA;AA/BR;AAkCM;;;;;;;;;;;;;;;;;;;;;;;EAEE,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,wBAAA;AAXR;AAcM;;;;;;;;;;;;;;;;;;;;;;;;EAEE,yBAAA;AAUR;AAJM;;;;;;;;EAQE,kCAAA;EACA,wCAAA;EACA,uBAAA;EACA,yBAAA;EACA,2BAAA;AAMR;AAJQ;;;;;;;;EACE,6CAAA;EACA,mDAAA;EACA,yBAAA;AAaV;AAVQ;;;;;;;;;;;;;;;EAEE,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,wBAAA;AAyBV;AAtBQ;;;;;;;;;;;;;;;;EAEE,yBAAA;AAsCV;AAhCE;EACE,qBDvRU;ACyTd;AAjCI;EACE,yBAAA;EACA,gCAAA;AAmCN;AA9BE;EACE,YAAA;AAgCJ;AA9BI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAgCN;AA7BI;EACE,aAAA;EACA,mBAAA;AA+BN;AA5BI;EACE,aAAA;EACA,mBAAA;AA8BN;AAzBE;EACE,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;AA2BJ;AAxBI;;;EAGE,sBAAA;AA0BN;AAvBM;;;EACE,qBAAA;EACA,0BAAA;EACA,iCAAA;EACA,yBAAA;EACA,oCAAA;EACA,oCAAA;AA2BR;AAzBQ;;;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;EACA,qBAAA;AA6BV;AA1BQ;;;;;EAEE,iCAAA;EACA,yBAAA;EACA,oCAAA;EACA,qBAAA;EACA,2BAAA;EACA,wBAAA;AA+BV;AA1BM;;;;;;;EAGE,uBAAA;EACA,8BAAA;AAgCR;AAxBM;EAEE,kCAAA;EACA,wCAAA;AAyBR;AAnBQ;EAEE,kCAAA;EACA,wCAAA;AAoBV;;AAZA;EACE,mBAAA;AAeF;;AAZA;EACE,eAAA;AAeF;;AAZA;EACE,cAAA;EACA,gBAAA;AAeF;;AAZA;EACE,kBAAA;AAeF;;AAZA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;AAeF;;AAZA;EACE,eAAA;AAeF;AAbE;EACE,YAAA;AAeJ;AAZE;EACE,mBAAA;EACA,YAAA;AAcJ;;AAVA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cD3aY;ACwbd;;AAVA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAaF;AAXE;EACE,yBAAA;UAAA,iBAAA;AAaJ;AAXI;EACE,yBAAA;UAAA,iBAAA;AAaN;AATE;EACE,mBAAA;EACA,0BAAA;AAWJ;AAPE;EACE,8BAAA;AASJ","sourcesContent":["/**\n * Created by Inzamam Janjua on 18/05/2023.\n */\n\n\n// Primary Color Palette\n\n$primaryBlue: #0A6ED9;\n$GreenBlue: #1C75BC;\n$Orange: #EF896A;\n$DarkSilver: #6C6D70;\n$BrightYellow: #F9A51D;\n$Green: #6ACE6A;\n$Greenlight: #7AEC7A;\n$GreenDark: #5CB85C;\n$white: #fff;\n$black: #000;\n$red:#C66A9E;\n// Standard System Colors\n\n$errorRed: #FF3C3C;\n$darkRed: #C11574;\n$lightRed: #FDF2FA;\n$successGreen: #10B981;\n$lightGreen: #ECFAF5;\n$lightOrange: #FFF2EB;\n$notificationYellow: #F9A51D;\n$lightBlue:rgba(226, 238, 255, 1);\n$headingText: #1E38A9;\n","@import \"../../assets/styles/colors.scss\";\n\n.layout-section {\n  padding: 1rem;\n}\n\n// File upload styles (matching AppLink module)\n.dropzone {\n  position: relative;\n  height: 200px;\n  width: 100%;\n  border: 2px dashed #D1D5DB;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  .textLink {\n    color: #1F2937 !important;\n\n    u {\n      text-decoration: underline;\n      margin-left: 4px;\n    }\n  }\n}\n\n.fileupload-info {\n  background: #f6f8ff;\n  padding: 15px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.fileupload-text {\n  display: block;\n  width: 85%;\n  word-wrap: break-word;\n}\n\n.table-wrapper {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n\n  // Match Medication Alerts/AppLink header icon styling\n  .user-label {\n    img {\n      width: 16px;\n      height: 16px;\n      flex-shrink: 0;\n    }\n\n    .layout-header-icon {\n      filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%)\n        hue-rotate(212deg) brightness(97%) contrast(92%) !important;\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n\n// Ensure form fields match user module styling\n:host ::ng-deep {\n  // Fix Add Sub Layout button - global override for PrimeNG\n  p-button.sub-layout-add-button {\n    opacity: 1 !important;\n\n    // Remove opacity from wrapper\n    &,\n    * {\n      opacity: 1 !important;\n    }\n\n    button.p-button:not(:disabled):not([disabled]),\n    .p-button:not(:disabled):not([disabled]),\n    button.p-button:not(.p-disabled),\n    .p-button:not(.p-disabled) {\n      opacity: 1 !important;\n      cursor: pointer !important;\n      background-color: #fff !important;\n      color: $headingText !important;\n      border: 1px solid $headingText !important;\n\n      &:hover {\n        opacity: 1 !important;\n        background: #f3f4f6 !important;\n        color: $headingText !important;\n        border-color: $headingText !important;\n      }\n\n      &:active,\n      &:focus {\n        opacity: 1 !important;\n        background-color: #fff !important;\n        color: $headingText !important;\n        border: 1px solid $headingText !important;\n      }\n    }\n\n    // Only apply opacity 0.5 when actually disabled\n    button.p-button:disabled,\n    .p-button:disabled,\n    button.p-button[disabled],\n    .p-button[disabled],\n    button.p-button.p-disabled,\n    .p-button.p-disabled {\n      opacity: 0.5 !important;\n      cursor: not-allowed !important;\n    }\n  }\n\n  .gc-form-section {\n    .gc-form-section-heading {\n      // Remove border-bottom when section is collapsed\n      &.collapsed {\n        border-bottom: none !important;\n      }\n    }\n\n    .sidebar-form {\n      // Ensure labels match user module style\n      label {\n        font-family: 'Montserrat';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 15px;\n        line-height: 30px;\n        color: $headingText;\n      }\n\n      // Ensure input fields match user module style\n      .p-inputtext {\n        height: 54px;\n        border: 1px solid #D1D5DB;\n        border-radius: 6px;\n        padding: 12px 16px;\n        font-family: 'Montserrat';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 30px;\n        color: #1f2937;\n        margin-bottom: 0;\n        &:enabled:focus {\n          box-shadow: none;\n          border-color: #D1D5DB;\n        }\n      }\n\n      // Reduce spacing between form fields\n      .grid.p-fluid {\n        .col-12 {\n          margin-bottom: 0.5rem;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n\n      .nested-form-group {\n        background: #f8f9fa;\n        padding: 1.5rem;\n        border-radius: 8px;\n        margin-bottom: 1.5rem;\n        border: 1px solid #dee2e6;\n\n        h4, h5 {\n          margin: 0;\n          color: $headingText;\n          font-weight: 600;\n          font-size: 18px;\n        }\n\n        .grid.p-fluid {\n          margin-bottom: 0;\n        }\n      }\n\n      .gc-form-section {\n        .gc-form-section {\n          margin-bottom: 1rem;\n          border: 1px solid #e5e7eb;\n\n          .gc-form-section-heading {\n            padding: 12px 16px;\n            h4 {\n              font-size: 16px;\n            }\n          }\n\n          .sidebar-form {\n            padding: 16px;\n          }\n        }\n      }\n    }\n  }\n\n  .p-sidebar-right {\n    width: 704px !important;\n  }\n\n  // Ensure delete buttons in form match table style (no background, just red icon)\n  // NOTE: In this module we use both <p-button> and <button pButton>. Target both.\n  // Also handle p-button-sm buttons to ensure no red background\n  // Target ALL buttons with danger class inside sidebar - most aggressive approach\n  .p-sidebar {\n    button.p-button-danger,\n    .p-button-danger,\n    button.p-button.p-button-danger,\n    .p-button.p-button-danger,\n    button.p-button-text.p-button-danger,\n    .p-button-text.p-button-danger,\n    button.p-button-text.p-button-danger.p-button-sm,\n    .p-button-text.p-button-danger.p-button-sm,\n    button.p-button.p-button-text.p-button-danger,\n    .p-button.p-button-text.p-button-danger,\n    button.p-button.p-button-text.p-button-danger.p-button-sm,\n    .p-button.p-button-text.p-button-danger.p-button-sm {\n      background: transparent !important;\n      background-color: transparent !important;\n      border: none !important;\n      color: #dc3545 !important;\n      box-shadow: none !important;\n\n      &:hover {\n        background: rgba(220, 53, 69, 0.1) !important;\n        background-color: rgba(220, 53, 69, 0.1) !important;\n        color: #c82333 !important;\n      }\n\n      &:focus,\n      &:active {\n        background: transparent !important;\n        background-color: transparent !important;\n        box-shadow: none !important;\n        outline: none !important;\n      }\n\n      .p-button-icon,\n      .pi {\n        color: #dc3545 !important;\n      }\n    }\n\n    // Target p-button component's inner button elements - must be very specific\n    p-button {\n      button.p-button-danger,\n      .p-button.p-button-danger,\n      button.p-button-text.p-button-danger,\n      .p-button.p-button-text.p-button-danger,\n      button.p-button-text.p-button-danger.p-button-sm,\n      .p-button.p-button-text.p-button-danger.p-button-sm,\n      button.p-button.p-button-text.p-button-danger,\n      .p-button.p-button-text.p-button-danger {\n        background: transparent !important;\n        background-color: transparent !important;\n        border: none !important;\n        color: #dc3545 !important;\n        box-shadow: none !important;\n\n        &:hover {\n          background: rgba(220, 53, 69, 0.1) !important;\n          background-color: rgba(220, 53, 69, 0.1) !important;\n          color: #c82333 !important;\n        }\n\n        &:focus,\n        &:active {\n          background: transparent !important;\n          background-color: transparent !important;\n          box-shadow: none !important;\n          outline: none !important;\n        }\n\n        .p-button-icon,\n        .pi {\n          color: #dc3545 !important;\n        }\n      }\n    }\n  }\n\n  .p-checkbox .p-checkbox-box {\n    border-color: $headingText;\n    &.p-highlight {\n      background-color: #2d388b;\n      border-color: #2d388b !important;\n    }\n  }\n\n  // Fix dropdown vertical alignment\n  .p-dropdown {\n    height: 54px;\n\n    .p-dropdown-label {\n      display: flex;\n      align-items: center;\n      height: 100%;\n      padding: 12px 16px;\n      line-height: 30px;\n    }\n\n    .p-dropdown-trigger {\n      display: flex;\n      align-items: center;\n    }\n\n    &.p-dropdown-empty .p-dropdown-label {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  // Fix Add Sub Layout button styling - ensure it looks enabled and has hover effect\n  ::ng-deep p-button.sub-layout-add-button {\n    width: auto !important;\n    min-width: 80px;\n    display: inline-block;\n    opacity: 1 !important;\n\n    // Target ALL possible button structures\n    button,\n    .p-button,\n    button.p-button {\n      width: auto !important;\n\n      // Force enabled appearance when not actually disabled\n      &:not([disabled]):not(.p-disabled) {\n        opacity: 1 !important;\n        cursor: pointer !important;\n        background-color: #fff !important;\n        color: $headingText !important;\n        border: 1px solid $headingText !important;\n        transition: all 0.2s ease !important;\n\n        &:hover {\n          background: #f3f4f6 !important;\n          color: $headingText !important;\n          border-color: $headingText !important;\n          opacity: 1 !important;\n        }\n\n        &:active,\n        &:focus {\n          background-color: #fff !important;\n          color: $headingText !important;\n          border: 1px solid $headingText !important;\n          opacity: 1 !important;\n          box-shadow: none !important;\n          outline: none !important;\n        }\n      }\n\n      // Disabled state\n      &[disabled],\n      &.p-disabled,\n      &:disabled {\n        opacity: 0.5 !important;\n        cursor: not-allowed !important;\n      }\n    }\n  }\n\n  // Final comprehensive override for ALL delete buttons in sidebar - maximum specificity\n  .p-sidebar {\n    * {\n      &[class*=\"p-button-danger\"],\n      &.p-button-danger {\n        background: transparent !important;\n        background-color: transparent !important;\n      }\n    }\n\n    p-button {\n      * {\n        &[class*=\"p-button-danger\"],\n        &.p-button-danger {\n          background: transparent !important;\n          background-color: transparent !important;\n        }\n      }\n    }\n  }\n\n}\n\n.gc-form-section {\n  margin-bottom: 2rem;\n}\n\n.sidebar-form {\n  padding: 0.5rem;\n}\n\n.red {\n  color: #FF3C3C;\n  margin-left: 2px;\n}\n\n.popup-wrapper {\n  position: relative;\n}\n\n.sidebar-interaction-blocker {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.7);\n  z-index: 1000;\n  cursor: not-allowed;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n}\n\n.gc-form-heading {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: $headingText;\n}\n\n.gc-form-section-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  &.cursor-pointer {\n    user-select: none;\n\n    h3, h4, h5 {\n      user-select: none;\n    }\n  }\n\n  .pi {\n    font-size: 0.875rem;\n    transition: transform 0.2s;\n  }\n\n  // Remove border-bottom when section is collapsed\n  &.collapsed {\n    border-bottom: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
